import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bde4370"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  ref: "modal",
  class: "modal show animate__animated animate__fadeIn",
  style: {"display":"block"}
}
const _hoisted_2 = {
  class: "modal-content",
  ref: "modalContent"
}
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}

export function render(_ctx, _cache) {
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-dialog", 'modal-' + _ctx.size])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              (_ctx.showTitle)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-header",
                    onMousedown: _cache[1] || (_cache[1] = $event => (_ctx.mouseDownHandDoc($event))),
                    onMouseup: _cache[2] || (_cache[2] = $event => (_ctx.mouseUpHandDoc($event)))
                  }, [
                    _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                    }, _hoisted_5)
                  ], 32))
                : _createCommentVNode("", true)
            ], true),
            _createElementVNode("div", {
              class: _normalizeClass(["modal-body", {'table-responsive': _ctx.tableResponsive, 'p-0': _ctx.noPadding}])
            }, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ], 2),
            _renderSlot(_ctx.$slots, "footer", {}, () => [
              (_ctx.showSubmitButton || _ctx.showCloseButton)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["modal-footer", {'justify-content-between': _ctx.showSubmitButton && _ctx.showCloseButton}])
                  }, [
                    (_ctx.showCloseButton)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          ref: "modalCloseButton",
                          type: "button",
                          class: _normalizeClass(["btn btn-default", {'text-right': !_ctx.showSubmitButton}]),
                          onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                        }, _toDisplayString(_ctx.closeButtonName), 3))
                      : _createCommentVNode("", true),
                    (_ctx.showSubmitButton)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          ref: "modalSubmitButton",
                          type: "button",
                          class: _normalizeClass(["btn btn-themes", {'text-right': !_ctx.showCloseButton}]),
                          onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.submitModal && _ctx.submitModal(...args)))
                        }, _toDisplayString(_ctx.submitButtonName), 3))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true)
            ], true),
            (_ctx.isLoading || _ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_svg_icon, {
                    name: "ali-loading",
                    size: "xl",
                    class: "turn"
                  })
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ], 2),
        _createElementVNode("div", {
          ref: "modalBackdrop",
          class: "modal-backdrop show",
          onClick: _cache[5] || (_cache[5] = _withModifiers((...args) => (_ctx.modalBackdropClick && _ctx.modalBackdropClick(...args)), ["self"])),
          onMousedown: _cache[6] || (_cache[6] = $event => (_ctx.mouseDownHandDoc($event))),
          onMouseup: _cache[7] || (_cache[7] = $event => (_ctx.mouseUpHandDoc($event)))
        }, null, 544)
      ], 512))
    : _createCommentVNode("", true)
}